/**
 * Get language from html element if present
 * @returns {string} - returns either lang attribute from html element as string or "de"
 */
export const getDocLang = (): string => {
  const htmlEl = <HTMLElement>window.self.document.querySelector("html");
  return htmlEl.getAttribute("lang") || "de";
};
